<template>
  <div class="ai-chat-message-failure">
    <m-icon
      type="warning"
      :color="$colors.red.base"
    />
    <span class="_text">
      {{ $t(`aiChat.failure.${reason}`) }}
    </span>
    <m-btn
      v-if="retryable"
      class="_retry"
      outlined
      color="danger"
      xxs
      @click="$emit('retry')"
    >
      {{ $t('aiChat.retry') }}
    </m-btn>
  </div>
</template>

<script setup>
defineProps({
  reason: {
    type: String,
    required: true,
  },
  retryable: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['retry']);
</script>

<style
  scoped
  lang="scss"
  type="text/scss"
>
  .ai-chat-message-failure {
    display: flex;
    flex-wrap: wrap;
    align-self: flex-start;
    align-items: center;
    gap: .6rem;
    max-width: 85%;
    color: $error-color;
  }
</style>
